// extracted by mini-css-extract-plugin
module.exports = {"root":"BodyRow_root__1YRJu"};